import React from 'react';
import { AiFillPhone, MdEmail, MdPerson } from 'react-icons/all';
import { IoIosContacts } from 'react-icons/io';
import { connect } from 'react-redux';
import { checkMot } from '../../ressources/functionJS/checkMot';
import logo from '../../ressources/itmlogo.png';
import * as s from '../../ressources/StyleGlobal/StyleGlobal';
import * as actions from '../../services/actions';
import styles from './Accueil.module.scss';

const Accueil = (props) => {
  return (
    <div className={styles.container}>
      <div className={[styles.bienvenue].join(' ')}>
        {checkMot('bienvenue')} <b>{props.prenom} </b>
        {checkMot('sur_la_platforme_argos')}{' '}
      </div>
      <a href="https://itmsol.fr/">
        <div className={styles.logo}>
          <img alt="logo" src={logo} className="" />
        </div>
      </a>
      <div className={[styles.contact, s.row].join(' ')}>
        <div className={[styles.titles, s.col_12].join(' ')}>
          <span className={styles.icon}>
            <IoIosContacts size={30} />
          </span>
          {checkMot('contacts_itmsol')}
        </div>
        <div className={[styles.car, s.card].join(' ')}>
          <div className={s.card_header}>{checkMot('direction')} :</div>
          <div className={s.card_body}>
            <div className={styles.lin}>
              <MdPerson size={20} color={'#EEB214'} /> M Eric Gastine
            </div>
            <div className={styles.lin}>
              <p>
                <AiFillPhone size={20} color={'#EEB214'} /> 07 61 01 77 50
              </p>
            </div>
            <div className={styles.lin}>
              <MdEmail size={20} color={'#EEB214'} />
              <a href="mailto:eric.gastine@itmsol.fr">
                {' '}
                eric.gastine@itmsol.fr
              </a>
            </div>
          </div>
        </div>
        <div className={[styles.car, s.card].join(' ')}>
          <div className={s.card_header}>{checkMot('operations')} :</div>
          <div className={s.card_body}>
            <div className={styles.lin}>
              <MdPerson size={20} color={'#EEB214'} />M Xavier LELONG
            </div>
            <div className={styles.lin}>
              <p>
                <AiFillPhone size={20} color={'#EEB214'} /> 06 21 43 68 97
              </p>
            </div>
            <div className={styles.lin}>
              <MdEmail size={20} color={'#EEB214'} />
              <a href="mailto:xavier.lelong@itmsol.fr">
                {' '}
                xavier.lelong@itmsol.fr
              </a>
            </div>
          </div>
        </div>
        <div className={[styles.car, s.card].join(' ')}>
          <div className={s.card_header}>{checkMot('maintenance')} :</div>
          <div className={s.card_body}>
            <div className={styles.lin}>
              <MdPerson size={20} color={'#EEB214'} />M Maxance Lu
            </div>
            <div className={styles.lin}>
              <p>
                <AiFillPhone size={20} color={'#EEB214'} /> 06 68 09 23 94
              </p>
            </div>
            <div className={styles.lin}>
              <MdEmail size={20} color={'#EEB214'} />
              <a href="mailto:maxance.lu@itmsol.fr"> maxance.lu@itmsol.fr</a>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

const mapStateToProps = (state) => {
  return {
    prenom: state.authentifie.name,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    supprimerAlerte: (alerteKey) => dispatch(actions.supprimer(alerteKey)),
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(Accueil);
